import type { SuggestionResource } from '@/kinds/suggestion'
import { useToasts } from '@/state/toasts'

/** What to call the agent a card started: its title, else the first line of its brief. */
export const agentTitle = (s: SuggestionResource) => {
  const op = s.spec.ops.find((o) => o.type === 'start_agent')
  const a = (op?.args ?? {}) as { title?: string; prompt?: string }
  const line = (a.title || a.prompt || '').split('\n')[0]!.trim()
  return line.length > 60 ? `${line.slice(0, 59).trimEnd()}…` : line
}

/** A card started a coding agent: say so, and let a tap open it. Nothing navigates by itself. */
export const announceAgent = (s: SuggestionResource, runId: string) => {
  const title = agentTitle(s)
  useToasts.getState().show(title ? `Agent started: ${title}` : 'Agent started', {
    to: `/agents/run/${runId}`,
  })
}
